import { Instance } from 'mobx-state-tree';
import { ExportColumnDtoModelBase } from './ExportColumnDtoModel.base';

/* The TypeScript type of an instance of ExportColumnDtoModel */
export interface ExportColumnDtoModelType extends Instance<typeof ExportColumnDtoModel.Type> {}

/* A graphql query fragment builders for ExportColumnDtoModel */
export { selectFromExportColumnDto, exportColumnDtoModelPrimitives, ExportColumnDtoModelSelector } from './ExportColumnDtoModel.base';

/**
 * ExportColumnDtoModel
 */
export const ExportColumnDtoModel = ExportColumnDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
